import type { GuestCommunicationChannel, PropertyCommunicationContent } from '@/shared/api';
import { contentKey, fieldsFor, LANGUAGE_LABEL, own, type Lang } from './editorModel';

/** Neben der Sprachwahl: wie beide Sprachen zusammen ankommen — oder wo eine noch Standard ist. */
export function languageHint(
  postStay: boolean,
  channel: GuestCommunicationChannel,
  content: PropertyCommunicationContent,
  lang: Lang,
) {
  if (channel === 'Ota') return 'Eine Nachricht, beide Sprachen – Gastsprache zuerst.';
  if (postStay) return 'Geht nur in der Sprache des Gasts.';
  const other: Lang = lang === 'De' ? 'En' : 'De';
  const gap = fieldsFor(channel).find(
    (field) =>
      own(content[contentKey(field.key, lang)]) !== null &&
      own(content[contentKey(field.key, other)]) === null,
  );
  return gap
    ? `„${gap.label}“ ist auf ${LANGUAGE_LABEL[other]} noch Standard.`
    : 'Eine E-Mail, beide Sprachen – Gastsprache zuerst.';
}

export function bodyHint(channel: GuestCommunicationChannel, postStay: boolean) {
  if (channel === 'Ota')
    return 'Das Feld wird an der Cursor-Position eingesetzt. {{ öffnet die Liste.';
  return postStay
    ? 'Tipp: {{ tippen öffnet die Feldliste.'
    : 'Tipp: {{ tippen öffnet die Feldliste. Der Link steht dort, wo das Feld steht.';
}
